var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SuusTextField',{attrs:{"id":"event-form__title","placeholder":_vm.t$('.enter_title'),"label":"Titel","autofocus":"","required":""},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})
}
var staticRenderFns = []

export { render, staticRenderFns }